import { NotificationEventTypes, NotificationEventTypeVariables, applicantPayload, recruiterPayload, eaPayload } from "app/types";

export const QuickVariables: React.FC<{
  eventType: string;
  recipientType?: string;
  onInsert: (variable: string) => void;
}> = ({ eventType, recipientType, onInsert }) => {
  const baseVariables = eventType
    ? NotificationEventTypeVariables[eventType as keyof typeof NotificationEventTypes] || []
    : [];

  let extraVariables: string[] = [];
  if (recipientType === 'jobseeker') extraVariables = applicantPayload;
  else if (recipientType === 'recruiter') extraVariables = recruiterPayload;
  else if (recipientType === 'employerAdmin') extraVariables = eaPayload;

  const variables = [...baseVariables, ...extraVariables];

  if (variables.length === 0) return null;

  return (
    <div className="mb-3">
      <div className="d-flex align-items-center mb-2">
        <i className="bi bi-magic me-2 text-primary"></i>
        <small className="fw-bold text-gray-700">Available Variables</small>
      </div>
      <div className="d-flex flex-wrap gap-2 p-3 bg-light rounded border border-dashed border-gray-300">
        {variables.map(variable => (
          <button
            key={variable}
            type="button"
            className="btn btn-sm btn-light-primary border border-primary border-opacity-10 shadow-sm transition-all hover-scale"
            onClick={() => onInsert(`{{${variable}}}`)}
            style={{
              fontSize: '12px',
              padding: '4px 10px',
              transition: 'all 0.2s ease'
            }}
            title={`Click to insert {{${variable}}}`}
          >
            <span className="fw-semibold text-primary opacity-75 me-1">{'{{'}</span>
            <span className="fw-bold text-gray-800">{variable}</span>
            <span className="fw-semibold text-primary opacity-75 ms-1">{'}}'}</span>
          </button>
        ))}
      </div>
      <div className="form-text mt-1 text-muted fs-8">
        Click on a variable to insert it into your message at the cursor position.
      </div>
    </div>
  );
};
